import {Injectable} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import * as moment from 'moment';
import {FilterObject} from '../../shared/models/FilterBarObject';
import {EventConfigurationMetaData, EventConfigurationResult} from '../models/events/event-interface';
import {EventDetailsResult, EventQueryResult, EventResultData} from '../models/events/event-query-result';
import {EventsFilter} from '../store/events/events.model';
import {GraphQLClientService} from './graphql-client.service';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  eventsTimeFrameMapper: any = {
    1: moment().subtract(1, 'hours').unix(),
    2: moment().subtract(24, 'hours').unix(),
    3: moment().subtract(7, 'days').unix()
  };

  public onScreenDialog = new Subject<boolean>();

  constructor(private oauthService: OAuthService, private graphQLClient: GraphQLClientService) {
  }

  public async getEvents(page: number = 1, count: number = 0, filter: FilterObject<EventsFilter>): Promise<EventResultData> {

    const timeFrame = filter?.filter?.timeFrame ? this.eventsTimeFrameMapper[filter.filter.timeFrame] : moment().subtract(10, 'days').unix();

    const query = `query{
      events(nameContains:"${filter?.search ? filter.search : ''}",
      ${filter.filter?.type !== null ? ` eventType:${filter.filter?.type}` : ''}, pageNumber:${page},
      ${timeFrame ? `startDate: ${timeFrame}, endDate: ${moment().unix()}` : ``})
          {
              results
               {id eventTypeId alert description eventTypeName generator location name time
                event{eventGeneratorId eventLocationId isAntipasbck}
                message{eventGeneratorId}
                alarm{eventGeneratorId eventLocationId
                        remarkInfo{
                            eventId alertId alarmDate description discussion links
                        }}
               }
                  totalCount
          }
       }`;

    return this.graphQLClient.requestAsync<EventQueryResult>(query).then((response) => {
      return response?.data?.events;
    }).catch(() => {
      return null;
    });
  }

  getEventDetailsById(eventTypeId: number): Promise<EventDetailsResult> {
    const query = `query{
       network(id:${eventTypeId})
      {
         id name address networkStatus networkStatusId controllers {panelId name statusDate statusDescription statusId typeDescription version}
          events { dateTime operator type nameAndDescription location}
      }
      }`;
    return this.graphQLClient.requestAsync<EventDetailsResult>(query).then(({data}) => {
      return data;
    }).catch(() => {
      return null;
    });
  }

  async antiPassBackForgive(eventData: any) {

    const query = `mutation($eventData: eventInput!){
      forgiveAntipassback(eventData: $eventData )
    }`;
    return (await this.graphQLClient.requestAsync<any>(query, eventData))?.data;

  }
  async updateAlert(eventData: any) {

    const query = `mutation{
      upsertAlertDismiss(eventData: {
      alertId: ${eventData.eventData.alertId}
      eventId: ${eventData.eventData.eventId}
      message: "${eventData.eventData.message}"
      } )
    }`;
    return (await this.graphQLClient.requestAsync<any>(query))?.data;

  }

  async deleteAlert(eventData: any) {

    const query = `mutation($eventData: eventInput!){
      deleteAlertDismiss(eventData: $eventData )
    }`;
    return (await this.graphQLClient.requestAsync<any>(query, eventData))?.data;

  }

  async getConfiguration(): Promise<EventConfigurationMetaData> {
    const query = `{
    configurations{
     eventConfigurations {eventTypes{id description}}
      }
    }`;
    return (await this.graphQLClient.requestAsync<EventConfigurationResult>(query))?.data.configurations.eventConfigurations;
  }
}
